
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ComponentDocs, Preview } from "@lighting-beetle/lighter-styleguide";
import { Checkbox, FormGrid, Input, Select, Textarea } from "./../";
import { Bar, BarItem, Grid, GridCol } from "./../../";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Form layouts`}</h1>
    <h2>{`Variants`}</h2>
    <h3>{`FormGrid`}</h3>
    <Preview mdxType="Preview">
  <FormGrid mdxType="FormGrid">
    <GridCol size={4} mdxType="GridCol">
      <Input id="form-grid-col-1" label="Input" mdxType="Input" />
    </GridCol>
    <GridCol size={4} mdxType="GridCol">
      <Checkbox id="form-grid-col-2" mdxType="Checkbox">Checkbox</Checkbox>
    </GridCol>
    <GridCol size={4} mdxType="GridCol">
      <Select id="form-grid-col-3" label="Select" mdxType="Select">
        <option>Item 1</option>
        <option>Item 2</option>
      </Select>
    </GridCol>
    <GridCol size={4} mdxType="GridCol">
      <Input id="form-grid-col-4" placeholder="Input" label="Input" mdxType="Input" />
    </GridCol>
    <GridCol size={8} mdxType="GridCol">
      <Textarea id="form-grid-col-5" placeholder="Textarea" label="Textarea" mdxType="Textarea" />
    </GridCol>
  </FormGrid>
    </Preview>
    <h3>{`Bar layout`}</h3>
    <Preview mdxType="Preview">
  <Bar align="middle" mdxType="Bar">
    <BarItem isFilling mdxType="BarItem">
      <Input id="bar-grid-col-1" label="Input" mdxType="Input" />
    </BarItem>
    <BarItem mdxType="BarItem">
      <Checkbox id="bar-grid-col-2" mdxType="Checkbox">Checkbox</Checkbox>
    </BarItem>
    <BarItem mdxType="BarItem">
      <Select id="bar-grid-col-3" label="Select" mdxType="Select">
        <option>Item 1</option>
        <option>Item 2</option>
      </Select>
    </BarItem>
  </Bar>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<FormGrid />" component={Grid} mdxType="ComponentDocs" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;